<template>
  <pf-modal
    :title="$t('Modifica il ricarico per i tuoi clienti')"
    variant="medium"
    :open="open"
    @update:open="$emit('update:open', $event)"
  >
    <x-form :id="formId" submit-text="" @submit="save">
      <form-group v-for="ccp of categories" :name="ccp.category">
        <x-input
          v-model="ccp.markup"
          :name="ccp.category"
          type="number"
          min="0"
          step="1"
          required
          append="%"
        />
      </form-group>
    </x-form>

    <template #footer>
      <pf-button type="submit" variant="primary" :form="formId">
        {{ $t('Salva') }}
      </pf-button>

      <pf-button variant="link" @click="emit('update:open', false)">
        {{ $t('Annulla') }}
      </pf-button>
    </template>
  </pf-modal>
</template>

<script lang="ts" setup>
import { ref, useId } from 'vue';
import { type CategoryCustomPrice, CategoryCustomPricesResource } from '@/resources';
import { cloneDeep } from 'lodash-es';

const props = defineProps<{
  open: boolean;
  categoryCustomPrices: CategoryCustomPrice[];
}>();

const formId = useId();
const categories = ref(cloneDeep(props.categoryCustomPrices));

const emit = defineEmits<{
  (e: 'submit'): void;
  (e: 'update:open', value: boolean): void;
}>();

async function save() {
  categories.value = categories.value.map(item => ({
    category: item.category,
    markup: Number(item.markup),
  }));
  await new CategoryCustomPricesResource().save(categories.value);
  emit('submit');
}
</script>
